// Import necessary modules from react-router-dom
import { Routes, Route } from 'react-router-dom';
import Styles from './app.module.scss';
import { Home } from '../home';
import { Contact } from '../contactMain';
import { About } from '../about';
import { Health } from '../healthPage';
import { Dashboard} from '../dashboardPage';
function App() {
  return (
    <div>
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/health" element={<Health />} />
          <Route path="/dashboard" element={<Dashboard />} />
        </Routes>
      </Layout>
    </div>
  );
}

const Layout = ({ children }) => (
  <div className={Styles.mainContainer}>
    <div className={Styles.contentContainer}>{children}</div>
  </div>
);

export { App };
